export const tasteAttributes = [
  { id: 'chocolate', name: 'Chocolate', icon: '🍫' },
  { id: 'nutty', name: 'Nutty', icon: '🥜' },
  { id: 'fruity', name: 'Fruity', icon: '🍓' },
  { id: 'floral', name: 'Floral', icon: '🌸' },
  { id: 'citrus', name: 'Citrus', icon: '🍋' },
  { id: 'caramel', name: 'Caramel', icon: '🍯' },
  { id: 'spicy', name: 'Spicy', icon: '🌶️' },
  { id: 'earthy', name: 'Earthy', icon: '🌱' },
  { id: 'roasted', name: 'Roasted', icon: '🔥' },
  { id: 'acidic', name: 'Acidic', icon: '⚡' },
  { id: 'bitter', name: 'Bitter', icon: '☕' },
  { id: 'sweet', name: 'Sweet', icon: '🍭' }
];
